export class CaptchaRequest{

    secret : string = "6LfNuKsUAAAAAHitnw97_cuhLDJShLnMa1i6E_jk"; //	Required. The shared key between your site and reCAPTCHA.
    response : string; // 	Required. The user response token provided by the reCAPTCHA client-side integration on your site.
}